import React, { ReactNode } from 'react';
import useRouteGuard from '../../hooks/useRouteGuard';
import AccessDeniedModal from './AccessDeniedModal';

interface RouteGuardProps {
  children: ReactNode;
  protectedPaths?: string[];
}

const RouteGuard: React.FC<RouteGuardProps> = ({ 
  children, 
  protectedPaths = ['/create', '/edit']
}) => {
  const { isAccessDenied, accessDeniedReason, closeModal } = useRouteGuard(protectedPaths);

  return (
    <>
      {children}
      <AccessDeniedModal
        isOpen={isAccessDenied}
        onClose={closeModal}
        reason={accessDeniedReason || 'permissions'}
      />
    </>
  );
};

export default RouteGuard;